var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrolley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "26.000000pt",
    height: "26.000000pt",
    viewBox: "0 0 26.000000 26.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,26.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 140 c-1 -55 -2 -105 -3 -112 -1 -6 5 -13 12 -16 7 -2 12 5 12 17 0 20 5 21 90 21 85 0 90 -1 90 -21 0 -12 5 -19 13 -17 6 3 12 10 11 16 -1 7 -2 57 -2 112 -1 59 -6 100 -12 100 -5 0 -10 -16 -10 -35 l0 -35 -90 0 -90 0 0 35 c0 19 -4 35 -10 35 -6 0 -11 -41 -11 -100z m201 -35 l0 -45 -90 0 -90 0 0 45 0 45 90 0 90 0 0 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 105 c-2 -29 1 -35 17 -35 26 0 33 13 25 45 -10 39 -39 33 -42 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 115 c-8 -32 -1 -45 25 -45 16 0 19 6 17 35 -3 43 -32 49 -42 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 224 c-12 -31 -6 -44 19 -44 25 0 31 13 19 44 -3 9 -12 16 -19 16 -7 0 -16 -7 -19 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 224 c-12 -31 -6 -44 19 -44 25 0 31 13 19 44 -3 9 -12 16 -19 16 -7 0 -16 -7 -19 -16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrolley);
export default __webpack_public_path__ + "static/media/trolley.51b148de5264f63e4454774a435c608b.svg";
export { ForwardRef as ReactComponent };